export type Videos = {
    id: number
    sectionId: number
    section: string
    embedId: string
}

export const VideosArray: Videos[] = [
    {
        id: 1,
        sectionId: 1,
        section: 'Fast Training',
        embedId: 'IT94xC35u6k',
    },
    {
        id: 2,
        sectionId: 1,
        section: 'Fast Training',
        embedId: 'RKYhcPV2dbA',
    },
    {
        id: 3,
        sectionId: 1,
        section: 'Fast Training',
        embedId: 'gBFvVIkPmww',
    },
    {
        id: 4,
        sectionId: 1,
        section: 'Fast Training',
        embedId: 'LvV7K_i7aDQ',
    },
    {
        id: 5,
        sectionId: 1,
        section: 'Fast Training',
        embedId: 'ZeJLIdQenTo',
    },
    {
        id: 6,
        sectionId: 2,
        section: 'Strength Training',
        embedId: 'WIHy-ZnSndA',
    },
    {
        id: 7,
        sectionId: 2,
        section: 'Strength Training',
        embedId: 'Q2cMMnUuKYQ',
    },
    {
        id: 8,
        sectionId: 2,
        section: 'Strength Training',
        embedId: 'fu4ZL6DQpPk',
    },
    {
        id: 9,
        sectionId: 2,
        section: 'Strength Training',
        embedId: 'qs9wyBQrNYA',
    },
    {
        id: 10,
        sectionId: 2,
        section: 'Strength Training',
        embedId: 'mwUcAe6ABI8',
    },
    {
        id: 11,
        sectionId: 3,
        section: 'Receipes',
        embedId: 'Lkl9_3-jX6c',
    },
    {
        id: 12,
        sectionId: 3,
        section: 'Receipes',
        embedId: 'wSnDpxMRf48',
    },
    {
        id: 13,
        sectionId: 3,
        section: 'Receipes',
        embedId: 'wkg_AyHE82w',
    },
    {
        id: 14,
        sectionId: 3,
        section: 'Receipes',
        embedId: 'sJO7jn3OXQ8',
    },
    {
        id: 15,
        sectionId: 3,
        section: 'Receipes',
        embedId: 'bC0JJlBQK6M',
    },
]
